import type { TrackClientEventParams } from './client';

export const trackClientEventLazy = async (params: TrackClientEventParams) => {
  try {
    // if user navigates away quickly or there's a network error this request might throw
    const { trackClientEvent } = await import('./client');
    return trackClientEvent(params);
  } catch {}
};
